module.exports = __webpack_public_path__ + "static/look-to-windward-defc562c4d74c5f463a8ad40cd0531ed.jpg";